// TODO: optimize for memory by not casting to date in sort fn -- need alternative sort then
export const sortModels = (data) =>
  data.sort((a, b) => new Date(a.dateModified) - new Date(b.dateModified)).reverse();

export const buildLastModifiedText = (dateModified) =>
  `${new Date(dateModified).toLocaleDateString()} at ${new Date(dateModified).toLocaleTimeString()}`;
